export default "__VITE_ASSET__BOy33PS6__"